import React from 'react'
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined'
import GoogleIcon from '../../../icon/GoogleIcon'
import { ReportTabs } from './reportTabs'
import { KPI_VALUE_TYPES } from './kpiValueFormatter'

export const KPI_SECTION_CARD_SX = { mb: 0 }

export const KPI_SUMMARY_TITLE_SX = {
  fontSize: { xs: 14, md: 13 },
  letterSpacing: 0,
  color: '#334155',
  ml: -2.5
}

export const KPI_SUMMARY_ICON_SX = {
  color: '#4672A3',
  '& svg': {
    transform: 'translateX(-10px)'
  }
}

const REPORT_MOTIVE_TITLES = {
  [ReportTabs.orders]: 'Motivos de No Visita - Pedidos',
  [ReportTabs.refunds]: 'Motivos de No Visita - Devoluciones',
  [ReportTabs.charges]: 'Motivos de No Visita - Cobros',
  [ReportTabs.deliveries]: 'Motivos de No Visita - Entregas'
}

export const buildSummaryCards = ({
  selectedTab,
  effectivenessPercentage,
  activeUsersCount,
  geofenceActivitiesCount,
  totalActivitiesCount,
  settlementDone,
  settlementTotal,
  posTaskDoneCount,
  posTaskTotalCount,
  chargeDocumentsPercentage,
  deliveriedDocumentsPercentage,
  isSingleDayRange = true
}) => {
  const settlementValue = isSingleDayRange
    ? {
        type: KPI_VALUE_TYPES.RATIO,
        numerator: settlementDone,
        denominator: settlementTotal
      }
    : { type: KPI_VALUE_TYPES.TEXT, value: 'N/A' }

  const baseCards = [
    {
      key: 'effectiveness',
      title: 'Efectividad',
      value: { type: KPI_VALUE_TYPES.PERCENT, value: effectivenessPercentage },
      icon: <TaskAltOutlinedIcon fontSize="small" />
    },
    {
      key: 'active-users',
      title: 'Usuarios activos',
      value: { type: KPI_VALUE_TYPES.COUNT, value: activeUsersCount },
      icon: <GroupOutlinedIcon fontSize="small" />
    },
    {
      key: 'geofence',
      title: 'Actividad dentro de geocerca',
      value: {
        type: KPI_VALUE_TYPES.RATIO,
        numerator: geofenceActivitiesCount,
        denominator: totalActivitiesCount
      },
      icon: <PlaceOutlinedIcon fontSize="small" />,
      wide: true
    }
  ]

  if (selectedTab === ReportTabs.summary) {
    return [
      ...baseCards,
      {
        key: 'pos-task',
        title: 'Tareas en punto de venta',
        value: {
          type: KPI_VALUE_TYPES.RATIO,
          numerator: posTaskDoneCount,
          denominator: posTaskTotalCount
        },
        icon: <ChecklistOutlinedIcon fontSize="small" />
      }
    ]
  }

  if (selectedTab === ReportTabs.charges) {
    return [
      ...baseCards,
      {
        key: 'effective-visits',
        title: 'Visitas efectivas',
        value: { type: KPI_VALUE_TYPES.PERCENT, value: effectivenessPercentage },
        icon: <TaskAltOutlinedIcon fontSize="small" />
      },
      {
        key: 'delivered-docs',
        title: 'Documentos entregados',
        value: { type: KPI_VALUE_TYPES.PERCENT, value: chargeDocumentsPercentage },
        icon: <ReceiptLongOutlinedIcon fontSize="small" />
      },
      {
        key: 'settlements',
        title: 'Usuarios con liquidación',
        value: settlementValue,
        icon: <ReceiptLongOutlinedIcon fontSize="small" />
      }
    ]
  }

  if (selectedTab === ReportTabs.deliveries) {
    return [
      ...baseCards,
      {
        key: 'effective-visits',
        title: 'Visitas efectivas',
        value: { type: KPI_VALUE_TYPES.PERCENT, value: effectivenessPercentage },
        icon: <TaskAltOutlinedIcon fontSize="small" />
      },
      {
        key: 'delivered-docs',
        title: 'Documentos entregados',
        value: { type: KPI_VALUE_TYPES.PERCENT, value: deliveriedDocumentsPercentage },
        icon: <ReceiptLongOutlinedIcon fontSize="small" />
      },
      {
        key: 'settlements',
        title: 'Usuarios con liquidación',
        value: settlementValue,
        icon: <ReceiptLongOutlinedIcon fontSize="small" />
      }
    ]
  }

  if (selectedTab === ReportTabs.pos) {
    return [
      ...baseCards,
      {
        key: 'pos-task',
        title: 'Tareas en punto de venta',
        value: {
          type: KPI_VALUE_TYPES.RATIO,
          numerator: posTaskDoneCount,
          denominator: posTaskTotalCount
        },
        icon: <ChecklistOutlinedIcon fontSize="small" />
      }
    ]
  }

  return baseCards
}

export const buildReportMotiveConfigs = ({
  selectedTab,
  noVisitReportMotivesOrder,
  noVisitReportMotivesRefund,
  noVisitReportMotivesCharge,
  noVisitReportMotivesDelivery
}) => {
  const dataByTab = {
    [ReportTabs.orders]: noVisitReportMotivesOrder,
    [ReportTabs.refunds]: noVisitReportMotivesRefund,
    [ReportTabs.charges]: noVisitReportMotivesCharge,
    [ReportTabs.deliveries]: noVisitReportMotivesDelivery
  }

  if (selectedTab === ReportTabs.summary) {
    return [
      {
        title: REPORT_MOTIVE_TITLES[ReportTabs.orders],
        data: noVisitReportMotivesOrder
      },
      {
        title: REPORT_MOTIVE_TITLES[ReportTabs.refunds],
        data: noVisitReportMotivesRefund
      },
      {
        title: REPORT_MOTIVE_TITLES[ReportTabs.charges],
        data: noVisitReportMotivesCharge
      },
      {
        title: REPORT_MOTIVE_TITLES[ReportTabs.deliveries],
        data: noVisitReportMotivesDelivery
      }
    ]
  }

  if (!REPORT_MOTIVE_TITLES[selectedTab]) {
    return []
  }

  return [
    {
      title: REPORT_MOTIVE_TITLES[selectedTab],
      data: dataByTab[selectedTab]
    }
  ]
}

export const buildTraceabilityCards = ({
  selectedTab,
  totalOrder,
  totalQuote,
  totalRefund,
  totalCharge,
  totalDelivery
}) =>
  [
    (selectedTab === ReportTabs.summary || selectedTab === ReportTabs.orders) && {
      key: 'orders',
      title: 'Total Pedidos',
      value: { type: KPI_VALUE_TYPES.CURRENCY, value: totalOrder },
      icon: <ShoppingCartOutlinedIcon fontSize="small" />
    },
    selectedTab === ReportTabs.summary && {
      key: 'quotes',
      title: 'Cotizaciones',
      value: { type: KPI_VALUE_TYPES.CURRENCY, value: totalQuote },
      icon: <GoogleIcon name="shopping_basket" size={20} />
    },
    (selectedTab === ReportTabs.summary || selectedTab === ReportTabs.refunds) && {
      key: 'refunds',
      title: 'Total Devoluciones',
      value: { type: KPI_VALUE_TYPES.CURRENCY, value: totalRefund },
      icon: <GoogleIcon name="replay" size={20} />
    },
    (selectedTab === ReportTabs.summary || selectedTab === ReportTabs.charges) && {
      key: 'charges',
      title: 'Total Cobros',
      value: { type: KPI_VALUE_TYPES.CURRENCY, value: totalCharge },
      icon: <PaymentsOutlinedIcon fontSize="small" />
    },
    (selectedTab === ReportTabs.summary || selectedTab === ReportTabs.deliveries) && {
      key: 'deliveries',
      title: 'Total Entregas',
      value: { type: KPI_VALUE_TYPES.CURRENCY, value: totalDelivery },
      icon: <LocalShippingOutlinedIcon fontSize="small" />
    }
  ].filter(Boolean)
